<template>
  <div></div>
</template>

<script lang="ts" setup>
import useMapbox from '@/composables/useMapbox'
import { CustomLayerInterface } from 'mapbox-gl'
import { computed, onBeforeUnmount, watch } from 'vue'
import { useStore } from 'vuex'
import { ADD_MAP_LAYER, REMOVE_MAP_LAYER } from '@/store/mutation-types'

const { map } = useMapbox()
const store = useStore()

type Props = {
  before?: string
  layer: CustomLayerInterface
}

const props = withDefaults(defineProps<Props>(), {
  before: ''
})

const beforeLayerId = computed(() => props.before)
const layer = computed(() => props.layer)
const mapIsLoaded = computed(() => store.state.mapIsLoaded)

function removeLayer() {
  map.removeLayer(layer.value.id)
  store.commit(REMOVE_MAP_LAYER, layer.value.id)
}
function addLayer() {
  map.addLayer(layer.value, beforeLayerId.value)
  store.commit(ADD_MAP_LAYER, layer.value.id)
}

watch(
  mapIsLoaded,
  (mapIsLoaded) => {
    if (!mapIsLoaded) return
    addLayer()
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  removeLayer()
})
</script>
